// extracted by mini-css-extract-plugin
module.exports = {"clientName":"JobClientDetails_clientName__s1fSp"};